'use strict'

function getAircraft(code, data) {
	const info = data.body.trips.data.aircraft;	
	for(let i = 0; i < info.length; i++) {
        if(code == info[i].code) {
            return info[i].name;
        }
	}	
}

function getCityName(code, data) {
	const info = data.body.trips.data.airport;
	let cityCode;
    for(let i = 0; i < info.length; i++) {
        if(code == info[i].code) {
            cityCode = info[i].city; 
        }
	}
	let cityInfo = data.body.trips.data.city;
	for(let i = 0; i < cityInfo.length; i++) {
        if(cityCode == cityInfo[i].code) {
            return cityInfo[i].name;
        }
	}
}

export { getAircraft, getCityName }



// WEBPACK FOOTER //
// ./util/helpers.js